export default {
  title: 'Raccourcis',
  links: {
    reservations: 'Réservations',
    orders_portal: 'Connexion terminal',
    closed: 'Fermé ?',
    menu: 'Modifier le menu',
    payouts: 'Rapports de paiement',
    opening_hours: "Horaires d'ouverture",
  },
};
